import { SimpleSelect, SimpleSelectProps } from '@aloft/toolkit-sui';

import { forwardRef } from 'react';

type SixTierQualityInputProps = Pick<
  SimpleSelectProps,
  'onChange' | 'onBlur' | 'name' | 'label' | 'required' | 'value'
>;

export const SixTierQualityInput = forwardRef<HTMLSelectElement, SixTierQualityInputProps>(
  (props, ref) => (
    <SimpleSelect size="sm" ref={ref} {...props}>
      <option value="1">Luxury</option>
      <option value="2">Semi-Luxury</option>
      <option value="3">Best Standard</option>
      <option value="4">Good Standard</option>
      <option value="5">Average Standard</option>
      <option value="6">Minimum Standard</option>
    </SimpleSelect>
  ),
);
